// extracted by mini-css-extract-plugin
export default {"row":"_34E3q"};